<template>
    <div ref="containerRef" class="scroll-container" @scroll="onScroll">

        <div v-if="list.length > 0">
            <div v-for="(item, index) in list" :key="index" class="explore"
                :style="item.background ? { backgroundImage: `url(${item.background})` } : undefined">
                <div class="absolute bottom-0 left-0 right-0 z-2">
                    <CustomSwipe :list="list.slice(0, 10)" bottom="18%" :index="index" width="100%" height="100vh"
                        :autoplay="100000000">
                        <template #default="{ item }">
                            <!-- header -->
                            <div class="explore-header flex items-center justify-between p-20px pt-52px!">
                                <div class="explore-header-left font-Kanit-BoldItalic">explore</div>
                            </div>

                            <!-- AI message -->
                            <div :class="{ show: showIndex === index }" v-if="item.descriptionNew"
                                class="message-box px-20px rounded-10px overflow-y-auto gradient-top-mask flex flex-col-reverse">
                                <div class="bg-#0A0A0A p-10px rounded-10px text-14px lh-20px color-#fff">
                                    <div class="message-content-html">
                                        {{ item.descriptionNew }}
                                    </div>
                                </div>
                            </div>

                            <!-- bottom -->
                            <div class="explore-bottom">
                                <div class="flex items-center mb-5px">
                                    <div
                                        class="text-20px font-500 color-#fff mr-8px max-w-200px truncate font-Kanit-Medium">
                                        {{ item.name }}
                                    </div>
                                    <div class="w-16px h-16px flex items-center justify-center">
                                        <!-- <img src="@/assets/images/explore/ic_more_small.svg" class="w-full h-full" /> -->
                                    </div>
                                    <div class="flex w-24px h-24px items-center justify-center ml-6px"
                                        v-if="item.isNew">
                                        <!-- <img src="@/assets/images/home/svg/new.webp" class="w-full h-full" /> -->
                                    </div>
                                </div>

                                <div class="relative">
                                    <div class="text-14px font-400 intro max-w-330px relative color-text-white-06">
                                        {{ item.descriptionNew }}
                                        <!-- {{ item.detail }} -->
                                        <!-- <div v-html="renderMarkdown((item.intro || ''))"></div> -->
                                    </div>
                                    <div class="absolute right--5px bottom-10px w-12px h-12px">
                                        <!-- <img src="@/assets/images/like/ic_unfold.svg" class="w-full h-full" /> -->
                                    </div>
                                </div>
                                <div class="intro-box mt-25px flex items-center justify-between">
                                    <div class="color-#777 text-14px font-400 font-Kanit-Regular color-text-06">
                                        whatDoYouWantToSay
                                    </div>
                                </div>
                            </div>
                        </template>
                    </CustomSwipe>
                </div>
            </div>
            <div class="bottom-mask">
            </div>
        </div>
        <div v-else-if="freshLoading" class="empty-container">
            <div class="explore-header flex items-center justify-between p-20px pt-52px!">
                <div class="explore-header-left">explore</div>
                <div class="explore-header-right flex items-center justify-center">
                    <div class="w-20px h-20px flex items-center justify-center mt-1px">
                        <!-- <img src="@/assets/images/explore/ic_coin.webp" class="w-full h-full" /> -->
                    </div>
                    <div class="text-14px font-500 color-#fff ml-4px">
                        <!-- {{ userStore.getMsgCost() ?? 0 }} -->
                    </div>
                </div>
            </div>
            <div class="p-20px pt-0">
                <div class="skeleton-block w-253px h-96px overflow-hidden rounded-10px bg-#5B5B5B mt-235px">
                </div>
                <div class="skeleton-line bg-#747474 w-66px rounded-4px h-18px mt-10px">
                </div>
                <div class="skeleton-line bg-#747474 w-100% rounded-4px h-18px mt-10px">
                </div>
                <div class="skeleton-line bg-#747474 w-285px rounded-4px h-18px mt-10px">
                </div>
                <div class="intro-box mt-25px flex items-center justify-between">
                    <div class="color-#777 text-12px font-400">whatDoYouWantToSay</div>
                    <div class="w-79px h-26px">
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="hasError" class="empty-container flex items-center justify-center flex-col"
            @click="handleReset">
            <!-- <img src="@/assets/images/home/ic_empty@2x.webp" class="w-79px h-75px" /> -->
            <div
                class="text-14px font-500 color-#fff mt-10px bg-#50DAFF p-7px rounded-25px px-30px text-16px font-Kanit-Bold">
                {{ t('explore.retry') }}</div>
        </div>
        <!-- loading / no more -->
        <div v-if="loading" class="loading">loading</div>
        <div v-if="noMore" class="loading">noMoreData</div>

        <div v-if="showGuidance"
            class="guidance fixed top-0 left-0 right-0 bottom-0 flex z-11 items-center justify-center w-100vw h-100vh bg-#000 bg-opacity-50">
            <Transition name="guidance-fade">
                1
                <!-- <img :src="guidance" class="w-180px h-128px guidance-img" /> -->
            </Transition>
        </div>
    </div>
</template>

<script setup lang="ts">
import CustomSwipe from "@/components/display/CustomSwipe.vue";
import { computed, ref, onMounted, nextTick, watch, onDeactivated, onActivated } from "vue";
// import guidance from "@/assets/images/explore/zhidao.webp";
import { useExploreStore } from "@/stores/explore";
// import { useUserStore } from "@/stores/userStore";
// import ChatIntro from "../chat/com/ChatIntro.vue";
// import empty from "@/assets/images/home/empty.webp";
// import emptyBG from "@/assets/images/me/version/占位@2x.webp";
import { useI18n } from 'vue-i18n'

import { useRouter } from 'vue-router'
import { useMarkdown } from '@/composables/useMarkdown';

const { t } = useI18n()
const router = useRouter()

interface AIItem {
    name: string;
    like: number;
    intro: string;
    message: string;
    cover?: string;
    detail?: any;
    chat_cover?: string;
    isNew?: boolean;
}
const GUIDANCE_KEY = 'explore_guidance_shown'
const showGuidance = ref(false)
const exploreStore = useExploreStore()
// const userStore = useUserStore()
const introText = ref<any>(null)
const showIntro = ref(false)
const { renderMarkdown } = useMarkdown()
const list = computed<any[]>(() => {
    const users = exploreStore.users
    // const roleDetails = exploreStore.roleDetails

    return users.map((u) => {
        // const detail = roleDetails[u.id] // 获取对应角色的详情

        return u
    })
})

const showIndex = ref(0);
const containerRef = ref<HTMLElement | null>(null);
const loading = computed(() => exploreStore.loading || exploreStore.loadingMore)
const noMore = computed(() => exploreStore.initialized && !exploreStore.hasMore && !loading.value)
const hasError = computed(() => exploreStore.hasError)
const freshLoading = computed(() => exploreStore.freshLoading)

const loadMore = async () => {
    await exploreStore.loadMore()
};

// 监听滚动
const onScroll = () => {
    if (!containerRef.value) return;
    const container = containerRef.value;
    const scrollTop = container.scrollTop;
    const index = Math.round(scrollTop / window.innerHeight);
    showIndex.value = index;

    // 滚动到底部加载更多
    if (container.scrollHeight - container.scrollTop - container.clientHeight < 100) {
        loadMore();
    }
};

function hideGuidance() {
    showGuidance.value = false
    localStorage.setItem(GUIDANCE_KEY, '1')
}

function handleUnfold(intro: string) {
    showIntro.value = true
    introText.value = intro
}

function handleIntroClose() {
    showIntro.value = false
}

const handleInput = (item: any) => {
    localStorage.setItem('path', '/explore')
    router.push({ name: 'Chat', query: { id: item.id, cover: item?.cover, name: item?.name } })
}

// 当前卡片变更时：自动滚动 message-box 底部，并拉取该角色详情
watch(showIndex, async (newIndex) => {
    nextTick(() => {
        const boxes = document.querySelectorAll(".message-box");
        const box = boxes[newIndex] as HTMLElement;
        if (box) box.scrollTop = box.scrollHeight;
    });

    const user = exploreStore.users[newIndex];
    if (user?.id) {
        try {
            await exploreStore.getRoleInfo(user.id);
        } catch (e) {
            console.error("getRoleInfo failed:", e);
        }
    }
});

const handleToStore = () => {
    router.push({ name: 'Store' })
}

function handleReset() {
    exploreStore.refresh()
}

onMounted(async () => {
    // 首次进入拉取 Explore 列表
    await exploreStore.refresh()

    // 拉取第一个角色的详情
    if (exploreStore.users[0]?.id) {
        exploreStore.getRoleInfo(exploreStore.users[0].id)
    }

    if (!localStorage.getItem(GUIDANCE_KEY)) {
        showGuidance.value = true
        // 3秒后自动消失
        setTimeout(() => {
            hideGuidance()
        }, 2000)
    }
    nextTick(() => {
        if (containerRef.value) containerRef.value.scrollTop = 0;
    });
});

// 记录离开时的索引
const lastIndex = ref(0)

onDeactivated(() => {
    lastIndex.value = showIndex.value
})

onActivated(() => {
    nextTick(() => {
        if (containerRef.value) {
            containerRef.value.scrollTop = lastIndex.value * window.innerHeight
        }
    })
})
</script>

<style scoped lang="scss">
.scroll-container {
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    scroll-snap-type: y mandatory;
    -webkit-overflow-scrolling: touch;
    background-color: #111;
}

.explore {
    height: 100vh;
    scroll-snap-align: start;
    position: relative;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    // background-image: url("https://muyuhan.s3.amazonaws.com/aiChat/test/original/20260112/009ccab961125c909737892958ef263b.webp");
}

.bottom-mask {
    height: 100px;
    background: linear-gradient(to top, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.9) 20%, rgba(0, 0, 0, 0.6) 40%, rgba(0, 0, 0, 0.3) 60%, rgba(0, 0, 0, 0) 100%);
    position: absolute;
    bottom: 50px;
    left: 0;
    right: 0;
    z-index: 0;
}

.message-box {
    // position: absolute;
    // bottom: 250px;
    // left: 0;
    // right: 0;
    margin-top: 100px;
    height: 200px;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    z-index: 10;
    opacity: 0;
    transform: translateY(60px);
    display: flex;
    flex-direction: column-reverse;
}

.message-box.show {
    animation: slideUpFadeIn 0.5s cubic-bezier(.22, 1, .36, 1) forwards;
}

@keyframes slideUpFadeIn {
    0% {
        opacity: 0;
        transform: translateY(60px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.explore-header {
    padding: 20px;
    color: #fff;
    background: linear-gradient(180deg, #0F0F0F 0%, rgba(34, 34, 34, 0) 100%);
}

.explore-header-left {
    font-size: 24px;
    font-style: italic;
    font-weight: 800;
}

.explore-header-right {
    background: #1b1821;
    border-radius: 22px;
    font-weight: 500;
    font-size: 14px;
    color: #fff;
    width: 84px;
    height: 32px;
    line-height: 32px;
    text-align: center;
}

.explore-bottom {
    position: absolute;
    bottom: 50px;
    width: 100%;
    padding: 20px;
    color: #bbb;
    z-index: 9;
    // background: linear-gradient(to top, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.9) 20%, rgba(0, 0, 0, 0.6) 40%, rgba(0, 0, 0, 0.3) 60%, rgba(0, 0, 0, 0) 100%);
    // padding-bottom: 62px;
}

.intro {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.35;
    max-height: calc(1.35em * 2);
    word-break: break-word;
    position: relative;
    color: rgba(255, 255, 255, 0.7);
}

.intro-box {
    width: 335px;
    height: 40px;
    background: #fff;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 7px 16px;
}

.loading {
    text-align: center;
    padding: 20px;
    color: #999;
}

.gradient-top-mask {
    mask-image: linear-gradient(180deg, transparent 0%, black 40px, black 100%);
    -webkit-mask-image: linear-gradient(180deg, transparent 0%, black 40px, black 100%);
}

/* 引导弹窗动画 */
.guidance-fade-enter-active {
    animation: guidance-in 0.4s ease;
}

.guidance-fade-leave-active {
    animation: guidance-out 0.4s ease forwards;
}

@keyframes guidance-in {
    from {
        opacity: 0;
        transform: scale(0.9);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

@keyframes guidance-out {
    from {
        opacity: 1;
        transform: scale(1);
    }

    to {
        opacity: 0;
        transform: scale(0.9);
    }
}

.guidance-img {
    animation: heartbeat 0.6s ease-in-out 3;
}

@keyframes heartbeat {
    0% {
        transform: scale(1);
    }

    25% {
        transform: scale(1.2);
    }

    50% {
        transform: scale(1);
    }

    75% {
        transform: scale(1.15);
    }

    100% {
        transform: scale(1);
    }
}

.empty-container {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

/* 骨架屏闪光动画 */
@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }

    100% {
        background-position: 200% 0;
    }
}

.skeleton-block,
.skeleton-line {
    position: relative;
    overflow: hidden;

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg,
                transparent 0%,
                rgba(255, 255, 255, 0.08) 30%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.08) 70%,
                transparent 100%);
        background-size: 200% 100%;
        animation: shimmer 1.8s ease-in-out infinite;
    }
}

.message-content-html {
    font-size: 16px;
    /* 全局开启换行与断行，处理没有被 <p> 包裹的文本节点 */
    white-space: pre-wrap;
    word-break: break-word;
    overflow-wrap: anywhere;

    :deep(p) {
        color: rgba(255, 255, 255, 0.6);
        white-space: pre-wrap;
        /* 保留换行 */
        word-break: break-word;
        /* 长单词断行 */
        overflow-wrap: anywhere;
        /* 连续字符换行 */
        margin: 0;
        /* 与 <br/> 搭配，避免额外间距 */

        // font-style: italic;
        font-size: 16px;
    }

    img {
        max-width: 100%;
        height: auto;
        display: block;
        border-radius: 6px;
    }



    :deep(em) {
        color: rgba(255, 255, 255, 0.6) !important;
    }

    // 🔧 对话和旁白样式
    :deep(.dialogue) {
        // 引号内的对话 - 白色
        color: #fff;
        // font-style: normal;
        font-family: 'Kanit-Regular';

        em {
            color: #fff !important;
            // font-style: normal;
            font-family: 'Kanit-Regular';

        }
    }

    em {
        font-family: 'Kanit-Regular';
    }

    :deep(.narration) {
        // 引号外的旁白 - 灰色
        color: rgba(255, 255, 255, 0.7);
        // opacity: 0.6;
        font-style: italic;
        font-size: 16px;
        // font-family: 'Kanit-Regular';
    }

    // 链接样式
    a {
        color: #1877F2;
        text-decoration: underline;

        &:hover {
            color: #166FE5;
        }

        &:active {
            color: #1460CC;
        }
    }

    // 标题样式
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        color: #fff;
        margin: 8px 0;
        line-height: 1.3;
    }

    // 强调/加粗

    // 行内代码
    code:not(.hljs) {
        background: rgba(255, 255, 255, 0.08) !important;
        color: #fff;
        padding: 2px 6px;
        border-radius: 6px;
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    }

    // 代码块（已由 highlight.js 样式表控制，这里微调暗色背景适配）
    pre.hljs {
        background: transparent !important;
        border-radius: 10px;
        padding: 12px;
        overflow-x: auto;
        white-space: pre-wrap; // 允许换行并保留缩进
        word-break: break-word; // 遇到长单词或长链接也换行
        overflow-wrap: anywhere; // 进一步保证超长连续字符可换行
    }

    // 使内部 code 继承换行策略
    pre.hljs code {
        white-space: inherit;
        word-break: inherit;
        overflow-wrap: inherit;
        max-width: 100%;
        display: block;
    }

    // 引用
    blockquote {
        border-left: 3px solid #1877F2;
        margin: 8px 0;
        padding: 6px 10px;
        background: rgba(255, 255, 255, 0.04);
        color: rgba(176, 179, 184, 0.8);
        border-radius: 6px;
    }

    // 列表
    ul li,
    ol li {
        color: rgba(255, 255, 255, 0.8);
        margin: 4px 0;
    }
}
</style>